import React from 'react'
import { Result } from 'antd-mobile'

import './error.less'

class ErrorBoundary extends React.Component<any, any> {
  constructor(props: any) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error: any) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  componentDidCatch(error: any, info: any) {
    // You can also log the error to an error reporting service
    //   logErrorToMyService(error, info);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div className="error-gl">
          <Result
            img={<img src="/public/assets/img/error.png" alt="" />}
            message={<div>哎呀！页面出现错误了~</div>}
          />
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
